<template>
    <section class="call-to-action grid grid__base"
            :class="rootClasses">
        <div class="call-to-action--container grid--container">
            <div class="call-to-action--row grid--row">
                <div class="call-to-action--col call-to-action--col__content grid--col">
                    <div class="call-to-action--content">
                        <h1 class="call-to-action--title u-reset">{{ title }}</h1>
                        <p class="call-to-action--text">{{ lead }}</p>
                        <conditional-link class="btn btn__primary btn__medium" v-bind="link"/>
                    </div>
                </div>
                <div class="call-to-action--col call-to-action--col__image grid--col">
                    <base-image class="call-to-action--image" :is-background="true" v-bind="image"/>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import bemMixin from 'framework/mixins/bem';
    import ConditionalLink from 'framework/components/conditional-link/conditional-link';
    import isMobileMixin from 'framework/mixins/is-mobile';

    export default {
        components: {
            ConditionalLink,
        },
        mixins: [bemMixin('call-to-action'), isMobileMixin],
        props: {
            title: {
                type: String,
                required: true,
            },
            /** @type { IImage } */
            image: {
                type: Object,
                default() {
                    return null;
                },
            },
            lead: {
                type: String,
                required: true,
            },
            /** @type { ILink } */
            link: {
                type: Object,
                required: true,
            },
        },
        computed: {
            rootClasses() {
                return [this.bemFacets, this.isMobile ? this.bemAdd('fluid', null, 'grid') : ''];
            },
        },
    };
</script>
